import { withCompInfo } from '../../core/withCompInfo'
import {
	SlideShowGalleryCarmiData,
	SlideShowGalleryDefinition,
	SlideShowGalleryProps,
	SlideShowGalleryCSS,
} from './types'

export const props = withCompInfo<SlideShowGalleryProps, SlideShowGalleryDefinition, SlideShowGalleryCarmiData>(
	['skin', 'compProps'],
	({ skin, compProps }, carmiData) => ({
		skin,
		items: carmiData.itemsProps,
		currentIndex: 0,
		shouldPreserveAspectRatio: compProps.imageMode === 'flexibleHeight',
		autoPlay: compProps.autoplay,
		autoPlayInterval: compProps.autoplayInterval * 1000,
	})
)

export const css = withCompInfo<SlideShowGalleryCSS, SlideShowGalleryDefinition>(
	['compLayout', 'compProps'],
	({ compLayout, compProps }) => ({
		height: compProps.imageMode === 'flexibleHeight' ? 'auto' : `${compLayout.height}px`,
		'--play-button-display': compProps.showAutoplay ? 'inline-block' : 'none',
	})
)
